import React, { FC, useEffect, useState } from 'react';
import { Button, Checkbox, CheckboxProps, Tag } from 'antd';
import { TDivisionResponse, TOrganizationResponse } from 'app/services/edpApiV1/moderator';
import ModalAddDivisions from '../modalAddDivisions/ModalAddDivisions';
import style from './index.module.scss';

type TProps = {
  selectedDivisions?: TDivisionResponse[];
  addDivisions: (users: TDivisionResponse[]) => void;
  selectedOrganizations?: TOrganizationResponse[];
  addOrganizations: (users: TOrganizationResponse[]) => void;
};

const PickDivisions: FC<TProps> = ({ selectedDivisions, addDivisions, addOrganizations, selectedOrganizations }) => {
  const [addUserModalOpen, setAddUserModalOpen] = useState<boolean>(false);
  const [isForAllEmployees, setIsForAllEmployees] = useState<boolean>(true);
  const [isForDivisions, setIsForDivisions] = useState<boolean>(true);
  const [isForOrganizations, setIsForOrganizations] = useState<boolean>(true);

  useEffect(() => {
    const isForDivisionsLocal = selectedDivisions?.length ? (selectedDivisions[0] === null ? false : true) : false;
    const isForOrganizationsLocal = selectedOrganizations?.length
      ? selectedOrganizations[0] === null
        ? false
        : true
      : false;

    setIsForOrganizations(isForOrganizationsLocal);
    setIsForDivisions(isForDivisionsLocal);
  }, [selectedDivisions, selectedOrganizations]);

  useEffect(() => {
    setIsForAllEmployees(!(isForDivisions || isForOrganizations));
  }, [isForDivisions, isForOrganizations]);

  const onAllUsersToggled: CheckboxProps['onChange'] = e => {
    setIsForAllEmployees(e.target.checked);
  };

  const handleSubmitAddUsersModal = () => {
    setIsForAllEmployees(!(selectedDivisions?.length || selectedOrganizations?.length));
    setAddUserModalOpen(false);
  };

  const handleCloseAddUsersModal = () => {
    setAddUserModalOpen(false);
  };
  const openModal = () => {
    setAddUserModalOpen(true);
  };

  const deleteDivisionTag = (id: string) => {
    if (selectedDivisions) {
      const newTags = selectedDivisions.filter(tag => tag?.id !== id);
      addDivisions(newTags);
    }
  };
  const deleteOrganizationTag = (id: string) => {
    if (selectedOrganizations) {
      const newTags = selectedOrganizations.filter(tag => tag?.id !== id);
      addOrganizations(newTags);
    }
  };

  return (
    <div className={style['pick-users']}>
      <div className={style['pick-users__top']}>
        <Checkbox checked={isForAllEmployees} onChange={onAllUsersToggled}>
          Всем сотрудникам
        </Checkbox>
        <Button type="primary" onClick={openModal} disabled={isForAllEmployees}>
          Добавить
        </Button>
      </div>
      {!isForAllEmployees ? (
        <div className={style['pick-users__bottom']}>
          <div className={style.tags}>
            {isForDivisions &&
              selectedDivisions?.map(tag => (
                <Tag closable onClose={() => deleteDivisionTag(tag?.id)} key={tag?.id} style={{ borderRadius: '10px' }}>
                  {tag?.name}
                </Tag>
              ))}
            {isForOrganizations &&
              selectedOrganizations?.map(tag => (
                <Tag
                  closable
                  onClose={() => deleteOrganizationTag(tag?.id)}
                  key={tag?.id}
                  style={{ borderRadius: '10px' }}
                >
                  {tag?.name}
                </Tag>
              ))}
          </div>
        </div>
      ) : null}
      <ModalAddDivisions
        open={addUserModalOpen}
        onOk={handleSubmitAddUsersModal}
        onCancel={handleCloseAddUsersModal}
        addDivisions={addDivisions}
        selectedDivisions={isForDivisions ? selectedDivisions : undefined}
        addOrganizations={addOrganizations}
        selectedOrganizations={isForOrganizations ? selectedOrganizations : undefined}
      />
    </div>
  );
};

export default PickDivisions;
